import React from "react";

function UserTable({ users }) {
  return (
    <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-300 p-6">
      <table className="min-w-full table-auto">
        <thead>
          <tr className="bg-gray-200">
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              #
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Name
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Place
            </th>
            <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700">
              Phone Number
            </th>
          </tr>
        </thead>
        <tbody>
          {users && users.length > 0 ? (
            users.map((user, index) => (
              <tr
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-gray-50" : "bg-white"
                } border-t hover:bg-blue-50 transition duration-150`}
              >
                <td className="py-3 px-4 text-sm text-gray-800 font-medium">
                  {index + 1}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">{user.name}</td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {user.place}
                </td>
                <td className="py-3 px-4 text-sm text-gray-800">
                  {user.phone_number}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="5"
                className="py-4 px-4 text-center text-sm text-gray-600 italic"
              >
                No verified users available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default UserTable;
